import { render, staticRenderFns } from "./VoucherPreviewForm.vue?vue&type=template&id=68550ca0&scoped=true"
import script from "./VoucherPreviewForm.vue?vue&type=script&lang=js"
export * from "./VoucherPreviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68550ca0",
  null
  
)

export default component.exports